//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState} from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box, Divider } from '@mui/material';

import {
  OpenInNew,
} from '@mui/icons-material';

// === HOOKS ===

// === COMPONENTS ===
import {ImagesMenuItem} from './components/ImagesMenuItem';
import {ThumbsMenuItem} from './components/ThumbsMenuItem';

// === API ===
import { onTask, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function DetachPanelMenu() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const ref   = useRef();
  const theme = useTheme();
  
  const [ is_open, setIsOpen ] = useState(false);

  const _hover_theme = theme.palette.mode === 'light' ? 'secondary' : 'primary';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      display    : 'flex'  ,
      marginLeft : 'auto'  ,
      alignItems : 'center',
      padding    : '0.5rem' ,
      cursor     : 'pointer',
      zIndex     : '50',
      '&:hover': {
        background: theme.palette.background[_hover_theme][theme.palette.mode],
      },
    },
    dropdown: {
      display: is_open ? '' : 'none',
      top: '0rem',
      right: '12rem',
      position: 'absolute',
      padding : 0,
    },
    info: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '-0.5px 0.5px 3px black',
      width: '100%',
      padding:'0.5rem',
      borderRadius: '0.5rem 0rem 0.5rem 0.5rem',
      
      text: {
        paddingLeft: '1rem',
      }
    }
  }

  const MENU = {
    children: <OpenInNew />,
    onClick: onClick_Menu,
  }

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleWindowSettings(data) {
      //-----------------------------------------------------------------

    } 
    
    onTask( handleWindowSettings );

    return () => {
      removeListener( 'PROKEY_WINDOW_SETTINGS', handleWindowSettings );
    };
  }, [] );
  
  useEffect(() => {
    if(is_open) document.addEventListener   ( 'click', handleClickOutside, true );
    else        document.removeEventListener( 'click', handleClickOutside, true );

    return () => {
      if(is_open) document.removeEventListener('click', handleClickOutside, true);
    };
  }, [is_open]);

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Menu() {
    //-----------------------------------------------------------------
    setIsOpen( !is_open );
  };

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} ref={ref} onClick={onClick_Menu} name='open_detach_menu_btn'>
        <Box sx={_styles.text}>Detach Panels</Box>
        <Box sx={_styles.dropdown}>
          <Box sx={_styles.info} >
            <ImagesMenuItem />
            <Divider />
            <ThumbsMenuItem />
          </Box>
        </Box>
      </Box>
    );
  };

  //#endregion

  return display();
}
